import useRootStore from './useRootStore';

export default function useLocation() {
  const { locationStore } = useRootStore();
  return locationStore;
}
